module.exports = __webpack_public_path__ + "media/images/icons/facebook-black-f23e1dcd0b09553e78f723a312a13958.svg";